module.exports = __webpack_public_path__ + "images/share-hint-arrow.231f3035.svg";